/**
 *  utm-capture
 *
 *  Remember a visitor's UTM values for the visit and put them in the enquiry
 *  form's hidden UTM fields, so they reach HubSpot even when the visitor lands
 *  on one page and enquires from another, or the form page came from a cache.
 *
 *  The fields are found by the atr-utm-<name> class added in
 *  framework/functions/utm_capture_fields.php. Keep UTM_NAMES in step with the
 *  list there.
 */

const STORAGE_KEY = 'atrUtm';
const UTM_NAMES = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const MAX_VALUE_LENGTH = 256;

// UTMs found on this page's URL, so storage being blocked doesn't lose them.
let capturedFromUrl = null;

function readStored() {
    try {
        return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
        return {};
    }
}

function writeStored(values) {
    try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(values));
    } catch (e) {
        // Storage can be blocked; capturedFromUrl still covers this page.
    }
}

/**
 * UTMs on the current URL. A new set replaces the old one, so a visit never
 * mixes the source of one ad with the campaign of another.
 */
function captureFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const found = {};

    UTM_NAMES.forEach((name) => {
        const value = (params.get(name) || '').trim().slice(0, MAX_VALUE_LENGTH);
        if (value) {
            found[name] = value;
        }
    });

    if (Object.keys(found).length) {
        capturedFromUrl = found;
        writeStored(found);
    }
}

/**
 * Once the visit has a set of UTMs it decides all five fields, blanking the
 * ones it doesn't have so an older value (the returning-guest cookie, say)
 * can't sit beside a newer touch. A visit with none leaves the fields alone.
 */
function fillFields() {
    const values = capturedFromUrl || readStored();

    if (!Object.keys(values).length) {
        return;
    }

    UTM_NAMES.forEach((name) => {
        document.querySelectorAll(`.atr-utm-${name} input`).forEach((input) => {
            input.value = values[name] || '';
        });
    });
}

function init() {
    captureFromUrl();
    fillFields();

    // Gravity Forms redraws the form between steps, and fires this when it does.
    // The native event, not jQuery's: jQuery isn't guaranteed to be loaded yet.
    document.addEventListener('gform/post_render', fillFields);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
